import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NbDialogRef } from "@nebular/theme";
import { NgImageSliderComponent } from "ng-image-slider";
import { environment } from "../../../environments/environment";

@Component({
  selector: "ngx-dialog-gallery",
  templateUrl: "dialog-gallery.component.html",
  styleUrls: ["dialog-gallery.component.scss"],
})
export class DialogGalleryComponent implements OnInit, AfterViewInit {
  @Input() imageObject?: any = [];
  @Input() imgIndex?: number = 0;

  @ViewChild("nav") slider: NgImageSliderComponent;

  constructor(protected ref: NbDialogRef<DialogGalleryComponent>) {}

  ngOnInit() {
    const img = environment.logoUrl;
    if (!this.imageObject) {
      this.imageObject = [];
      this.imageObject.push({
        image: img,
        thumbImage: img,
        title: "",
      });
    }

    if (!this.imgIndex) {
      this.imgIndex = 0;
    }

    console.log(this.imageObject);
    console.log(this.imgIndex);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.slider.imageOnClick(this.imgIndex);
    });
  }

  close($event) {
    this.ref.close();
  }
}
